import { Facility } from "./facility.definition";
import { UserInfo } from "./user.definition";

export const DEFAULT_MANAGER_IMAGE_MALE = "/image/manManager.png";
export const DEFAULT_MANAGER_IMAGE_FEMALE = "/image/womanManager.png";

export type Manager = UserInfo & ManagerInfo;
export type ManagerInfo = {
  id: number;
  userId?: number;
  healthcareFacility: Facility;
};

export type ManagerUpdate = Omit<Manager, "id" | "healthcareFacility">;
